import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./dashboard/Drawer";
import Header from "./dashboard/Header";
import useAuth from "../hooks/useAuth";

export default function DashboardLayout() {
  useAuth()
  return (
    <Box
      sx={(theme) => ({
        width: "100%",
        maxWidth: "none",
        marginRight: "auto",
        marginLeft: "auto",
        [theme.breakpoints.down("sm")]: {
          width: "100%",
          maxWidth: 768,
        },
      })}
    >
      <Header />
      <Box
        sx={{
          backgroundColor: "white",
          position: "relative",
        }}
      >
        <Sidebar />
        <Box
          sx={(theme) => ({
            backgroundColor: "white",
            marginLeft: 0,

            [theme.breakpoints.up("md")]: {
              width: `calc(100% - 300px)`,
              marginLeft: "300px",
            },
            [theme.breakpoints.down("sm")]: {
              marginTop: "48px"
            },
          })}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
